"use client"

import { useCustomerProfile, useMerchantCouponRedeemer, useMerchantProfile } from "@/hooks/useGlobalStore"
import CustomerHeader from "../customer/CustomerHeader"
import MerchantHeader from "../merchant/MerchantHeader"
import MerchantCouponRedeemerHeader from "../merchantCouponRedeemer/MerchantCouponRedeemerHeader"
import NonAuthHeader from "./NonAuthHeader"

export default function SpectraHeader() {
  const { merchantProfile } = useMerchantProfile({ required: false })
  const { customerProfile } = useCustomerProfile({ required: false })
  const { merchantCouponRedeemer } = useMerchantCouponRedeemer({ required: false })

  const Wrapper = ({ children }: { children: React.ReactNode }) => (
    <header className="sticky top-0 z-50 border-b bg-background">
      <div className="p-2 xl:mx-4">{children}</div>
    </header>
  )

  if (merchantProfile) {
    return (
      <Wrapper>
        <MerchantHeader />
      </Wrapper>
    )
  }

  if (customerProfile) {
    return (
      <Wrapper>
        <CustomerHeader />
      </Wrapper>
    )
  }

  if (merchantCouponRedeemer) {
    return (
      <Wrapper>
        <MerchantCouponRedeemerHeader />
      </Wrapper>
    )
  }

  return (
    <Wrapper>
      <NonAuthHeader />
    </Wrapper>
  )
}
